import React from 'react';
import NavigationBar from '../NavigationBar';
import ShellMainWithStickyAdRail from './ShellMainWithStickyAdRail';
import styles from '../../styles/layout/PageShell.module.css';

/**
 * PageShell - Minimal page wrapper
 * Provides the navigation bar and basic content structure.
 * Use this for simple pages that don't need game-specific features.
 * 
 * Note: Modal functionality is now provided globally via ModalContext.
 * The navigation bar's streak/gettoncini buttons will work automatically.
 * 
 * @param {React.ReactNode} children - Page content
 * @param {function} onBack - Optional back button handler (shows back arrow instead of hamburger)
 * @param {string} backIcon - Custom back button icon (default: "fas fa-chevron-left")
 * @param {Array} menuItems - Custom menu items for the drawer
 * @param {boolean} showStickyAdRail - Whether to render the shared sticky right ad rail
 */
const PageShell = ({ 
  children, 
  onBack,
  backIcon,
  menuItems,
  showStickyAdRail = true,
}) => {
  return (
    <>
      <div data-google-interstitial="false">
        <NavigationBar 
          onBack={onBack}
          backIcon={backIcon}
          menuItems={menuItems}
        />
      </div>
      <div data-google-interstitial="false">
        <ShellMainWithStickyAdRail
          as="main"
          className={styles.content}
          showStickyAdRail={showStickyAdRail}
          railPlacementBase="page-shell-sticky-rail"
          testId="page-shell-main-layout"
        >
          {children}
        </ShellMainWithStickyAdRail>
      </div>
    </>
  );
};

export default PageShell;
